
import WithModel from '@/mixins/withModel';
import { mixins, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import {markRaw} from 'vue';

@Options({})
export default class webMap extends mixins(WithModel) {

    @Prop() userPosition: OM.LatLong;
    @Prop() center: OM.LatLong;
    @Prop() markers: OM.VillageTrip[];
    
    mounted(){
        this.init();
    }

    init(){
        let map = new google.maps.Map(this.$refs.mapElement, {
            center: { lat: this.center.lat, lng: this.center.long },
            zoom: 12,
            mapId: "webmap",
            disableDefaultUI: true,
            clickableIcons: false
        });

        this.setCenterFn = (val: OM.LatLong) => {
            map.panTo({
                lat: val.lat,
                lng: val.long
            });
        }

        let markers = [];
        this.markers.forEach(x => {
            // A marker with a with a URL pointing to a PNG.
            const tripImage = document.createElement('img');
            tripImage.width = 52;
            tripImage.height = 52;
            tripImage.style.objectFit = "cover";
            tripImage.style.borderRadius = "50%";
            tripImage.src = x.image.publicUrl;

            const marker = new google.maps.marker.AdvancedMarkerElement({
                map: map,
                position: { lat: x.position.lat, lng: x.position.long },
                content: tripImage,
                gmpClickable: true
            });
            marker.addListener('click', ({ domEvent, latLng }) => {
                this.$emit('markerClick', x);
            });
            markers.push(marker);
        })

        const iconLocation = document.createElement('img');
        iconLocation.width = 52;
        iconLocation.height = 52;
        iconLocation.style.objectFit = "cover";
        iconLocation.style.borderRadius = "50%";
        iconLocation.src = require('@/img/icon-location.svg');
        const userPositionMarker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: { lat: this.userPosition.lat, lng: this.userPosition.long },
            content: iconLocation,
        });

        this.positionChangeFn = (val: OM.LatLong) => {
            userPositionMarker.position = {
                lat: val.lat,
                lng: val.long
            }
        };
    }

    positionChangeFn = (val: OM.LatLong) => {};
    setCenterFn = (val: OM.LatLong) => {};

    @Watch('userPosition')
    @Watch('userPosition.lat')
    @Watch('userPosition.long')
    onPositionChange(next, prev){
        this.positionChangeFn(this.userPosition); 
    }

    @Watch('center')
    @Watch('center.lat')
    @Watch('center.long')
    onCenterChange(next, prev){
        this.setCenterFn(this.center); 
    }


}
